import {useQuery} from 'react-query';
import { getThreads } from '../api';
import { useDiscussionFilters } from '../context/DiscussionFilters';

export const DISCUSSION_LIST_CACHE_KEY = 'DISCUSSION_LIST';

export const useDiscussionList = () => {
  const {tagFilter} = useDiscussionFilters();

  console.log(tagFilter, 'tagFilter')

  const keys = [DISCUSSION_LIST_CACHE_KEY, tagFilter];

  return useQuery(keys, async () => {
    const threads = await getThreads({
      tag: tagFilter
    });

    return threads;
  });
};